<template>
  <section
    class="new-case-view case-creation"
    id="single-case-view"
    v-loading="loading"
  >
    <div class="container-sm">
      <div class="case-status" v-if="this.caseInfo && this.caseInfo.status">
        <ul class="justify-content-end">
          <li>
            <h3 class="name">Sendout Status</h3>  
          </li>
          <li>
            <el-dropdown
              v-if="hasPermission('cases', 'edit')"
              @command="(command) => changeStatus(command, caseId)"
              trigger="click"
            >
              <el-button
                type="success"
                size="medium"
                class="px-010"
                :class="this.caseInfo.status"
              >
                <span class="pr-5" v-if="caseInfo.status === 'COMPLETE'"
                  >FINALIZED</span
                >
                <span class="pr-5" v-else>{{
                  this.caseInfo.status.split("_").join(" ")
                }}</span>
                <i class="el-icon-success"></i>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    command="ACTIVE"
                    :disabled="caseInfo.status === 'ACTIVE'"
                  >
                    <span class="px-10">ACTIVE</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <el-button
              v-else
              :type="
                this.caseInfo.status !== 'COMPLETE' ? 'primary' : 'success'
              "
              class="this.caseInfo.status"
              >{{
                this.caseInfo.status !== "COMPLETE" ? "PROCESSING" : "COMPLETE"
              }}</el-button
            >
          </li>
        </ul>
      </div>
      <div>
        <PatientInformation></PatientInformation>
        <span class="case-creation__divider"></span>
        <CaseInformation></CaseInformation>
        <span class="case-creation__divider"></span>
        <TestInformation></TestInformation>
        <span class="case-creation__divider"></span>
        <div v-if="showMedication">
          <Medication></Medication>
        </div>
        <span class="case-creation__divider"></span>
        <TestReports></TestReports>
        <span class="case-creation__divider"></span>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
const PatientInformation = defineAsyncComponent(() =>
  import("@/components/sendOuts/PatientInformation")
);
const CaseInformation = defineAsyncComponent(() =>
  import("@/components/sendOuts/CaseInformation")
);
const TestInformation = defineAsyncComponent(() =>
  import("@/components/sendOuts/ReceivedViewTests")
);
const TestReports = defineAsyncComponent(() =>
  import("@/components/sendOuts/TestReports")
);
const Medication = defineAsyncComponent(() =>
  import("@/components/sendOuts/Medication")
);
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import { mapGetters } from "vuex";
export default {
  components: {
    PatientInformation,
    CaseInformation,
    TestInformation,
    TestReports,
    Medication,
  },
  mixins: [UserPermissionsHelper],
  data() {
    return {
      loading: false,
      caseInfo: {},
    };
  },
  computed: {
    ...mapGetters("sendOuts", [
      "getShowMedication",
      "getReceivedSendOutInformation",
      "getUpdateSendOutStatus",
    ]),
    showMedication() {
      if (
        this.getReceivedSendOutInformation &&
        this.getReceivedSendOutInformation.case_types &&
        (this.getReceivedSendOutInformation.case_types.indexOf("PGX_TEST") !=
          -1 ||
          this.getReceivedSendOutInformation.case_types.indexOf("TOXICOLOGY") !=
            -1)
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.checkSendOutInformation();
  },
  methods: {
    async changeStatus(command, id) {
      try {
        let params = {
          status: command,
          id: id,
        };
        await this.$store.dispatch("cases/changeCaseStatus", params, {
          root: true,
        });

        if (
          this.getUpdateSendOutStatus &&
          this.getUpdateSendOutStatus.success
        ) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateSendOutStatus.message,
          });

          this.caseInfo.status = command;
        } else {
          this.$notify.error({
            title: "Failed",
            message: "Status Not Updated",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkSendOutInformation() {
      try {
        this.loading = true;
        this.sendOutId = this.$route.params.send_out_id;
        await this.$store.dispatch("sendOuts/fetchReceivedSendOutInformation", {
          send_out_id: this.sendOutId,
        });
        this.caseInfo = JSON.parse(
          JSON.stringify(this.getReceivedSendOutInformation)
        );
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
